import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import Kitchen from '../../../app/data/models/kitchens/kitchen';

export interface KitchenStaffKitchenListState {
  kitchens: Kitchen[];
  status: string;
}

const initialState: KitchenStaffKitchenListState = {
  kitchens: [],
  status: 'idle',
};

export const fetchKitchenStaffKitchenListAsync = createAsyncThunk<
  Kitchen[],
  string
>('kitchens/list', async (restaurantId, thunkApi) => {
  try {
    return await api.KitchenStaffRestaurant.kitchens(restaurantId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const kitchenStaffKitchenListSlice = createSlice({
  name: 'kitchens',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchKitchenStaffKitchenListAsync.pending, (state) => {
      state.status = 'pendingFetchKitchens';
    });
    builder.addCase(
      fetchKitchenStaffKitchenListAsync.fulfilled,
      (state, action) => {
        state.kitchens = action.payload;
        state.status = 'idle';
      }
    );
    builder.addCase(fetchKitchenStaffKitchenListAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
